import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {allpayments} from "models/allpayments"; // Importing allpayments model
import {devConfig} from "config/config"; // Importing development configuration

/**
 * Class representing the tableBetsReportView.
 * @extends JetView
 */
export default class tableBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var direction = false; // Variable to track sorting direction
        var vthis = this; // Reference to the current instance

        // Custom data filter for summing values in a tree column
        webix.ui.datafilter.summTreeColumn = webix.extend({
            refresh: function (master, node, value) {
                var result = 0; // Variable to hold the sum result
                var resultFormat = 0; // Variable for formatted result
                master.data.each(function (obj) {
                    if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                });
                // Formatting result based on column ID
                if (value.columnId === 'CantidadTickets') {
                    resultFormat = webix.i18n.intFormat(result);
                } else {
                    resultFormat = webix.i18n.priceFormat(result);
                }
                node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
            }
        }, webix.ui.datafilter.summColumn); // Extending the summColumn filter

        // Custom data filter for summing values in a regular column
        webix.ui.datafilter.mySummColumn = webix.extend({
            refresh: function (master, node, value) {
                var result = 0; // Variable to hold the sum result
                var resultFormat = 0; // Variable for formatted result
                var size = $$('datatable2').getPager().config.size; // Page size
                var page = $$('datatable2').getPage(); // Current page
                var first = size * page; // First item index on the current page
                var last = (first + size) - 1; // Last item index on the current page
                var count = 0; // Counter for items

                master.data.each(function (obj) {
                    if (count >= first && count <= last) {
                        result += parseFloat(obj[value.columnId]); // Summing values within the current page
                    }
                    count++;
                });
                resultFormat = webix.i18n.priceFormat(result); // Formatting the result
                node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
            }
        }, webix.ui.datafilter.summColumn); // Extending the summColumn filter

        return {
            rows: [{
                cols: [
                    {
                        view: "datatable", // Data table component
                        id: "datatable", // Unique identifier for the datatable
                        css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                        scheme: {
                            // Data scheme can be defined here
                        },
                        scrollY: true, // Enable vertical scrolling
                        columns: [
                            {
                                id: "Date", header: _("Fecha Creación"), width: 200, // Column for creation date
                                template: function (obj, common) {
                                    if (obj.$group) return common.datatable(obj, common) + obj.value; // Grouping logic
                                    return obj.Date; // Return date value
                                },
                                footer: "Total:" // Footer label
                            },
                            {
                                id: "detailTittle", header: "", width: 50, height: 25, tooltip: _("Detalles"), // Column for details icon
                                template: function (obj) {
                                    if (obj.$level == 1) {
                                        return ""; // No details for level 1
                                    } else {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Details icon
                                    }
                                }
                            },
                            {id: "Id", header: _("Ticket Id"), width: 100}, // Column for Ticket ID
                            {id: "ClientId", header: _("ID Cliente"), width: 100}, // Column for Client ID
                            {id: "TypeBe", header: _("Tipo de Apuesta"), width: 150}, // Column for Bet Type
                            {id: "BetShop", header: _("Punto de Venta"), width: 150}, // Column for Bet Shop
                            {id: "DatePayment", header: _("Fecha de pago"), width: 150}, // Column for Payment Date
                            {id: "BetShopPayment", header: _("Punto Venta Pagó"), width: 100, sort: "int"}, // Column for Payment Shop
                            {id: "Cashier", header: _("Cajero"), width: 150}, // Column for Cashier
                            {id: "UserId", header: _("Usuario Id"), width: 100}, // Column for User ID
                            {id: "UserName", header: _("Usuario"), width: 250, hidden: !devConfig.getPermAction("sensitiveInformationNames", "Add")}, // Column for User Name with permission check
                            {
                                id: "State", header: _("Estado"), width: 80, options: [ // Column for State with options
                                    {"id": "C", "value": _("Abierto")},
                                    {"id": "S", "value": _("Ganó")},
                                    {"id": "N", "value": _("Perdió")},
                                    {"id": "A", "value": _("No Acción")},
                                    {"id": "R", "value": _("Pendiente")},
                                    {"id": "W", "value": _("En Espera")},
                                    {"id": "J", "value": _("Rechazada")},
                                    {"id": "M", "value": _("Rechazada por Regla")},
                                    {"id": "T", "value": _("Retiro Voluntario")},
                                    {"id": "PP", "value": _("Pendiente por pagar Punto de venta")}
                                ]
                            },
                            {id: "ClosingDate", header: _("Fecha Cierre"), width: 150}, // Column for Closing Date
                            {id: "BeneficiaryId", header: _("Beneficiario Id"), width: 100}, // Column for Beneficiary ID
                            {
                                id: "Amount", // Column for Amount
                                header: _("Valor"),
                                format: webix.i18n.priceFormat, exportType: "number", // Formatting and export type
                                width: 100,
                                footer: {content: "summColumn"} // Footer content
                            },
                            {
                                id: "WinningAmount", // Column for Winning Amount
                                header: _("Premios"),
                                format: webix.i18n.priceFormat, exportType: "number", // Formatting and export type
                                width: 100,
                                footer: {content: "summColumn"} // Footer content
                            },
                            {
                                id: "Tax", // Column for Tax on Winning
                                header: _("Impuesto Premios"),
                                format: webix.i18n.priceFormat, exportType: "number", // Formatting and export type
                                width: 100,
                                footer: {content: "summColumn"} // Footer content
                            },
                            {
                                id: "TaxBet", // Column for Tax on Bet
                                header: _("Impuesto Apuesta"),
                                format: webix.i18n.priceFormat, exportType: "number", // Formatting and export type
                                width: 100,
                                footer: {content: "summColumn"} // Footer content
                            },
                            {
                                id: "WinningAmountTotal", // Column for Total Winning Amount
                                header: _("Premio Total"),
                                format: webix.i18n.priceFormat, exportType: "number", // Formatting and export type
                                width: 100,
                                footer: {content: "summColumn"} // Footer content
                            },
                            {id: "Odds", header: _("Odds"), width: 100}, // Column for Odds
                            {id: "UserIP", header: "IP", width: 150}, // Column for User IP
                            {id: "Wallet", header: _("Billetera"), width: 100} // Column for Wallet
                        ],
                        onClick: {
                            "details": function (euv, id) { // Click event for details icon
                                var item = this.getItem(id); // Get the clicked item
                                this.$scope.app.callEvent("user:id", [item.Id]); // Trigger user ID event
                                if (screen.width < 500 || screen.height < 500) {
                                    $$("filterDetails").show(); // Show details for small screens
                                    $$("filterDetails2").show();
                                } else {
                                    $$("dColl").expand(); // Expand details for larger screens
                                    $$('a5').scrollTo(0, 1000); // Scroll to specific position
                                }
                            }
                        },
                        on: {
                            onBeforeLoad: function () { // Event before loading data
                                this.showOverlay("<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>"); // Show loading overlay
                            },
                            onAfterLoad: function () { // Event after loading data
                                this.hideOverlay(); // Hide loading overlay
                            }
                        },
                        ready: function () { // Event when the datatable is ready
                            if (!this.count()) { // Check if there are no items
                                webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + "</div>"); // Show no data overlay
                            }
                        },
                        footer: true, // Enable footer
                        tooltip: true, // Enable tooltips
                        math: true, // Enable math calculations
                        loadahead: 0, // Load ahead configuration
                        datafetch: devConfig.getDefaultDataFetch(), // Fetch data configuration
                        pager: "pagerA" // Pager ID
                    },
                    {
                        view: "treetable", // Tree table component
                        id: "datatable2", // Unique identifier for the tree table
                        css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                        scrollY: true, // Enable vertical scrolling
                        columns: [
                            {
                                id: "Date", header: _("Fecha Creación"), width: 260, format: dateFormat, // Column for creation date with formatting
                                template: function (obj, common) {
                                    if (obj.$group) return common.treetable(obj, common) + obj.value; // Grouping logic
                                    return obj.Date; // Return date value
                                },
                                footer: "Total:" // Footer label
                            },
                            {
                                id: "detailTittle", header: "", width: 50, height: 25, tooltip: _("Detalles"), // Column for details icon
                                template: function (obj) {
                                    if (obj.$level < 5) {
                                        return ""; // No details for levels below 5
                                    } else {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Details icon
                                    }
                                }
                            },
                            {id: "Id", header: _("Ticket Id"), width: 100}, // Column for Ticket ID
                            {id: "BetShop", header: _("Punto de Venta"), width: 170}, // Column for Bet Shop
                            {id: "DatePayment", header: _("Fecha de pago"), width: 150}, // Column for Payment Date
                            {id: "BetShopPayment", header: _("Punto Venta Pagó"), width: 160, sort: "int"}, // Column for Payment Shop
                            {id: "Cashier", header: _("Cajero"), width: 150}, // Column for Cashier
                            {id: "UserId", header: _("Usuario Id"), width: 80}, // Column for User ID
                            {id: "UserName", header: _("Usuario"), width: 200}, // Column for User Name
                            {
                                id: "State", header: _("Estado"), width: 80, options: [ // Column for State with options
                                    {"id": "C", "value": _("Abierto")},
                                    {"id": "S", "value": _("Ganó")},
                                    {"id": "N", "value": _("Perdió")},
                                    {"id": "A", "value": _("No Acción")},
                                    {"id": "R", "value": _("Pendiente")},
                                    {"id": "W", "value": _("En Espera")},
                                    {"id": "J", "value": _("Rechazada")},
                                    {"id": "M", "value": _("Rechazada por Regla")},
                                    {"id": "T", "value": _("Retiro Voluntario")}
                                ]
                            },
                            {id: "CurrencyId", header: _("Moneda"), width: 100}, // Column for Currency
                            {id: "BeneficiaryId", header: _("Beneficiario Id"), width: 100}, // Column for Beneficiary ID
                            {
                                id: "Amount", // Column for Amount
                                header: _("Valor"),
                                format: webix.i18n.priceFormat, exportType: "number", // Formatting and export type
                                width: 120,
                                footer: {content: "summTreeColumn"} // Footer content
                            },
                            {
                                id: "WinningAmount", // Column for Winning Amount
                                header: _("Premios"),
                                format: webix.i18n.priceFormat, exportType: "number", // Formatting and export type
                                width: 120,
                                footer: {content: "summTreeColumn"} // Footer content
                            },
                            {
                                id: "Tax", // Column for Tax on Winning
                                header: _("Impuesto Premios"),
                                format: webix.i18n.priceFormat, exportType: "number", // Formatting and export type
                                width: 120,
                                footer: {content: "summTreeColumn"} // Footer content
                            },
                            {
                                id: "TaxBet", // Column for Tax on Bet
                                header: _("Impuesto Apuesta"),
                                format: webix.i18n.priceFormat, exportType: "number", // Formatting and export type
                                width: 120,
                                footer: {content: "summTreeColumn"} // Footer content
                            },
                            {
                                id: "WinningAmountTotal", // Column for Total Winning Amount
                                header: _("Premio Total"),
                                format: webix.i18n.priceFormat, exportType: "number", // Formatting and export type
                                width: 120,
                                footer: {content: "summTreeColumn"} // Footer content
                            },
                            {id: "Odds", header: _("Odds"), width: 100}, // Column for Odds
                            {id: "UserIP", header: "IP", width: 150}, // Column for User IP
                            {id: "Wallet", header: _("Billetera"), width: 100} // Column for Wallet
                        ],
                        onClick: {
                            "details": function (euv, id) { // Click event for details icon
                                var item = this.getItem(id); // Get the clicked item
                                this.$scope.app.callEvent("user:id", [item.Id]); // Trigger user ID event
                                $$("dColl").expand(); // Expand details
                                $$('a5').scrollTo(0, 1000); // Scroll to specific position
                            }
                        },
                        on: {
                            onBeforeLoad: function () { // Event before loading data
                                this.showOverlay("<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>"); // Show loading overlay
                            },
                            onAfterLoad: function () { // Event after loading data
                                this.hideOverlay(); // Hide loading overlay
                            }
                        },
                        ready: function () { // Event when the tree table is ready
                            if (!this.count()) { // Check if there are no items
                                webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + "</div>"); // Show no data overlay
                            }
                        },
                        footer: true, // Enable footer
                        tooltip: true, // Enable tooltips
                        math: true, // Enable math calculations
                        loadahead: devConfig.getDefaultDataFetch(), // Fetch data configuration
                        pager: {
                            size: 10000, // Pager size
                            id: "pagerA2" // Pager ID
                        }
                    }
                ]
            }]
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The main grid component.
     */
    init(grid) {
        var gridppal = $$('datatable'); // Main datatable reference
        var grid2 = $$('datatable2'); // Secondary datatable reference
        $$("toolbar2").hide(); // Hide secondary toolbar
        grid2.hide(); // Hide secondary datatable
        var url = devConfig.geturlApi() + "null/Report/GetBetHistory"; // API URL for fetching bet history
        const _ = this.app.getService("locale")._; // Localization service
        var flag = false; // Flag for export functionality

        grid2.attachEvent("onAfterLoad", function () { // Event after loading data in grid2
            $$("datatable2").data.group({ // Grouping data by UserName
                by: "UserName",
                map: {
                    UserId: ["UserId"],
                    Date: ["UserName"],
                    Partner: ["Partner"],
                    Country: ["Country"],
                    CountryIcon: ["CountryIcon"],
                    CurrencyId: ["CurrencyId"],
                    Amount: ["Amount", "sum"],
                    WinningAmount: ["WinningAmount", "sum"],
                    Tax: ["Tax", "sum"],
                    WinningAmountTotal: ["WinningAmountTotal", "sum"]
                }
            });
            $$("datatable2").data.group({ // Grouping data by CurrencyId
                by: "CurrencyId",
                map: {
                    Partner: ["Partner"],
                    Country: ["Country"],
                    CountryIcon: ["CountryIcon"],
                    CurrencyId: ["CurrencyId"],
                    Amount: ["Amount", "sum"],
                    WinningAmount: ["WinningAmount", "sum"],
                    Tax: ["Tax", "sum"],
                    WinningAmountTotal: ["WinningAmountTotal", "sum"]
                }
            });
            $$("datatable2").data.group({ // Grouping data by Country with icon
                by: function (obj) { return "<i class='flags " + obj.CountryIcon + "'></i>" + obj.Country; },
                map: {
                    Partner: ["Partner"],
                    Country: ["Country"],
                    CountryIcon: ["CountryIcon"],
                    Amount: ["Amount", "sum"],
                    WinningAmount: ["WinningAmount", "sum"],
                    Tax: ["Tax", "sum"],
                    WinningAmountTotal: ["WinningAmountTotal", "sum"]
                }
            });
            $$("datatable2").data.group({ // Grouping data by Partner
                by: function (obj) { return "<i class='partner " + obj.Partner + "'></i>"; },
                map: {
                    Partner: ["Partner"],
                    Amount: ["Amount", "sum"],
                    WinningAmount: ["WinningAmount", "sum"],
                    Tax: ["Tax", "sum"],
                    WinningAmountTotal: ["WinningAmountTotal", "sum"]
                }
            });
        });

        var filter = ""; // Variable to hold filter string
        this.on(this.app, "casinoReport:filter", filterData => { // Event for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ""; // String for date filters
            var string2 = ""; // String for sorting filters
            var providergroup = 0; // Provider group flag

            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == "IsDetails") { // Check for details flag
                    if (object[i][1] == 0) {
                        // No action needed
                    } else {
                        providergroup = 1; // Set provider group flag
                    }
                }
                if (object[i][0] == "Sort") { // Check for sorting
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[Date]='; // Sort by Date
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[UserId]='; // Sort by User ID
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Amount]='; // Sort by Amount
                            }
                            if (object[i][1] == '4') {
                                string2 = string2 + '&sort[GGR]='; // Sort by GGR
                            }
                        }
                    }
                }
                if (object[i][0] == "Dir") { // Check for sorting direction
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc'; // Ascending order
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc'; // Descending order
                        }
                    }
                }
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) { // Check for non-object filters
                    if (object[i][0] == "DateStart") { // Date start filter
                        var date = object[i][1].split(" - ");
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] == "DateEnd") { // Date end filter
                            var date = object[i][1].split(" - ");
                            console.log(date);
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to filter
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to filter
                        } else {
                            if (object[i][0] != "Sort" && object[i][0] != "Dir" && object[i][0] != "Date" && object[i][0] != "Date2") {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                            } else {
                                if (object[i][0] == "Date") { // Date filter
                                    var date = object[i][1].replace(" 00:00:00", "");
                                    string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                    string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                                }
                                if (object[i][0] == "Date2") { // Second date filter
                                    var date = object[i][1].replace(" 00:00:00", "");
                                    string1 = string1 + '&dateFrom2=' + date; // Add dateFrom2 to filter
                                    string1 = string1 + '&dateTo2=' + date; // Add dateTo2 to filter
                                }
                            }
                        }
                    }
                } else {
                    if ((typeof object[i][1] === "object")) { // Check for object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === "start") { // Start date filter
                                    var d = new Date(object2[j][1]);
                                    var dateFrom = "dateFrom=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === "end") { // End date filter
                                        var d = new Date(object2[j][1]);
                                        var dateTo = "dateTo=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (providergroup == 0) { // Check if provider group is not set
                gridppal.show(); // Show main grid
                grid2.hide(); // Hide secondary grid
                gridppal.clearAll(); // Clear main grid data
                gridppal.load(url + '?start=0&count=' + gridppal.data.$pagesize + string1 + string2); // Load data with filters
                $$("toolbar").show(); // Show main toolbar
                $$("toolbar2").hide(); // Hide secondary toolbar
            } else {
                grid2.show(); // Show secondary grid
                gridppal.hide(); // Hide main grid
                grid2.clearAll(); // Clear secondary grid data
                grid2.load(url + '?start=0&count=' + grid2.data.$pagesize + string1 + string2); // Load data with filters
                grid2.adjust(); // Adjust secondary grid layout
                $$("toolbar2").show(); // Show secondary toolbar
                $$("toolbar").hide(); // Hide main toolbar
            }
            filter = string1 + string2; // Update filter variable
            $$("filterPopup").hide(); // Hide filter popup
        });

        gridppal.attachEvent("onAfterSort", function (by, dir, as) { // Event after sorting main grid
            gridppal.load(url + '?start=0&count=' + gridppal.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        gridppal.attachEvent("onItemClick", function (id, e, node) { // Event on item click in main grid
            // Additional logic can be added here
        });

        this.on(this.app, "player:select", id => { // Event for player selection
            gridppal.load(gridppal.data.url + '?start=0&count=' + gridppal.data.$pagesize + '&PlayerId=' + id); // Load data for selected player
        });

        this.on(this.app, "export:filter", filterData => { // Event for exporting data
            flag = true; // Set export flag
            var firstfirst; // Variable for first item in export
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first item index
            } else {
                firstfirst = filterData.first; // Keep first item index
            }
            gridppal.load(url + '?start=' + (firstfirst) + '&count=' + (filterData.last + 1) + filter); // Load data for export
            gridppal.attachEvent("onAfterLoad", function () { // Event after loading data for export
                if (flag) { // Check if export flag is set
                    var size = gridppal.getPager().config.size; // Get pager size
                    var page = gridppal.getPage(); // Get current page
                    var first = size * page; // First item index on current page
                    var last = (first + size) - 1; // Last item index on current page
                    if ($$("Export").getValue() == '1') { // Check for Excel export
                        for (var j = 0; j < gridppal.config.columns.length; j++) {
                            if (gridppal.config.columns[j].exportType) {
                                delete gridppal.config.columns[j].format; // Remove format for export
                            }
                        }
                        this.app.callEvent("export:data", [{ // Trigger export event
                            NameReport: _("Apuestas") + ($$("datatable").count() > 0 ? "" : _(" - No hay datos")) + " - " + new Date().toLocaleString(),
                            TypeReport: "Excel"
                        }]);
                        webix.toExcel(gridppal, { // Export to Excel
                            filter: function (obj) {
                                return gridppal.getIndexById(obj.id) >= first && gridppal.getIndexById(obj.id) <= last; // Filter for current page
                            },
                            filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", { hour12: true }).replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase() + " - " + ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Apuestas"),
                            ignore: { "detailTittle": true }, // Ignore detail title in export
                            footer: false // Do not include footer in export
                        });
                    } else {
                        if ($$("Export").getValue() == '2') { // Check for PDF export
                            this.app.callEvent("export:data", [{ // Trigger export event
                                NameReport: _("Apuestas") + ($$("datatable").count() > 0 ? "" : _(" - No hay datos")) + " - " + new Date().toLocaleString(),
                                TypeReport: "PDF"
                            }]);
                            webix.toPDF(gridppal, { // Export to PDF
                                filter: function (obj) {
                                    return gridppal.getIndexById(obj.id) >= first && gridppal.getIndexById(obj.id) <= last; // Filter for current page
                                },
                                filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", { hour12: true }).replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase() + " - " + ($$("datatable").count() > 0 ? "" : _("No hay datos - ")) + _("Apuestas"),
                                autowidth: true, // Auto width for PDF
                                ignore: { "detailTittle": true }, // Ignore detail title in export
                                footer: false // Do not include footer in export
                            });
                        }
                    }
                    flag = false; // Reset export flag
                    $$("Export").setValue(""); // Reset export selection
                }
            }.bind(this));
        });
    }
}

// FILE DOCUMENTED
